module.exports = __webpack_public_path__ + "img/logo_nacional.ae864ed8.png";